import React from 'react';
import block from 'propmods';

import './Description.scss';

const b = block('Description');

type DescriptionTheme = 'caption' | 'default';

interface Props {
    offsetTop?: boolean;
    offsetBottom?: boolean;
    theme?: DescriptionTheme;
}

const Description: React.SFC<Props> = ({ children, offsetTop = true, offsetBottom = false, theme = 'caption' }) => (
    <div
        {...b({
            'offset-top': offsetTop,
            'offset-bottom': offsetBottom,
            theme,
        })}
    >
        {children}
    </div>
);

export default Description;
